export { default } from './resolveProps';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/resolveProps/index.js
// module id = 187
// module chunks = 22